/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_PublishedInputs */

const en_mobile_ota_published = /** @type {(inputs: Mobile_Ota_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

const es_mobile_ota_published = /** @type {(inputs: Mobile_Ota_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicada`)
};

/**
* | output |
* | --- |
* | "Published" |
*
* @param {Mobile_Ota_PublishedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_published = /** @type {((inputs?: Mobile_Ota_PublishedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_PublishedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_published(inputs)
	return en_mobile_ota_published(inputs)
});